import {ValueObject} from '@s-ui/domain'

export class RecommendedAdsListValueObjectFactory extends ValueObject {
  /**
   * @param {Object} items
   * @param {Object} metadata
   * @param {boolean} isRecommendedAdsFallback
   */
}
